import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.14;
  letter-spacing: ${-0.3 / 14}em;
  color: ${({ theme }) => theme.colors.textLight};
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 8px 0;
  width: 100%;
`;

export default function QuickViewButton({ handleClick, ...rest }) {
  return (
    <StyledButton onClick={handleClick} variant="unstyled" {...rest}>
      <FormattedMessage
        id="global_cta.quick_view_title"
        defaultMessage="Quickview"
      />
    </StyledButton>
  );
}

QuickViewButton.propTypes = {
  handleClick: PropTypes.func,
};
